import React, { Component }  from 'react';
import { withRouter }        from 'react-router';
import { connect }           from 'react-redux';
//import { isLoggedIn }        from '../../../../utils/authService';
//import { TemplateConstants } from '../environment';

//var apiHost = TemplateConstants.WebApiHost;

class AdminLanding extends Component {
  constructor(props) {
    super(props);
    this.state = { 

    };
  }

  componentDidMount() {
    
  }
  
  componentWillUnmount(){
    
  }

  render() {
    return (
      <div>
        Hello from the Template Admin Landing
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminLanding));
